<template>
<div class="modal-dialog  modal-fullscreen">
    <div class="modal-content"  >
        <div class="modal-header bg-primary">
            <h2 class="modal-title text-white fw-bolder col-md-10">
                 {{ $t('design_template') }} 
            </h2>  
            <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal" ::aria-label="$t('close')" ref="closeDesignModal"
                @click="this.$parent.isShow.DesignerModal = false;">
                <span class="svg-icon svg-icon-1 text-white text-hover-dark">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                            transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                        <rect x="7.41422" y="6" width="16" height="2" rx="1"
                            transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                    </svg>
                </span>
            </div>
        </div>
        <div class="modal-body">
            <div class="content flex-row-fluid mt-4" id="kt_content">
                <div class="card card-xxl-stretch">
                    <div class="p-10">
                        <div class="row">
                            <div class="col-lg-12">
                                <table class="table table-rounded table-striped table-bordered border gy-3 gs-3">
                                    <tbody>
                                        <tr class="border">
                                            <td class="fw-bold"> {{ $t('category') }} </td>
                                            <td> 
                                                 {{ $t('bank_transaction') }} 
                                            </td>
                                        </tr>
                                        <tr class="border">
                                            <td class="fw-bold"> {{ $t('name') }} </td>
                                            <td>{{  form.name }}</td>
                                        </tr>
                                        <tr class="border">
                                            <td class="fw-bold"> {{ $t('file_type') }} </td>
                                            <td>
                                                <span v-if="form.file_type_id == 0"> {{ $t('not_selected') }} </span>
                                                <span v-if="form.file_type_id == 1"> {{ $t('excel') }} </span>
                                                <span v-if="form.file_type_id == 2"> {{ $t('xml') }} </span>
                                                <span v-if="form.file_type_id == 3"> {{ $t('csv') }} </span> 
                                            </td>
                                        </tr>
                                        <tr class="border">
                                            <td class="fw-bold"> {{ $t('bank') }} </td>
                                            <td>{{  form.related_account_name }}</td>
                                        </tr>
                                        <tr class="border">
                                            <td class="fw-bold"> {{ $t('description') }} </td>
                                            <td>{{  form.description }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div> 
                        <!-- WORKSHEET TABS -->
                        <div class="mb-5">
                            <div class="d-grid">
                                <ul class="nav nav-tabs flex-nowrap text-nowrap">
                                    <div class="nav-item mt-4 me-3">
                                        <span>
                                             {{ $t('worksheets') }}  
                                        </span>
                                    </div>
                                    <li class="nav-item" v-for="item, index in this.addedWorksheets" v-bind:key="item">
                                        <a :ref="el => { if (el) buttonRefs[index] = el }" :id="'WorksheetTab_' + index"
                                            class="nav-link btn btn-active-light btn-color-gray-600 btn-active-color-primary rounded-bottom-0 border border-gray-200" 
                                            data-bs-toggle="tab" :href="'#kt_tab_pane_ws_' + index"
                                            @click="this.GetExcelDataByRecordID(item.name)">
                                        <strong> {{  item.name }}  </strong>
                                        <small v-if="item.virtual_name !== null && item.virtual_name !== '' && item.virtual_name !== undefined && item.virtual_name !== item.name">({{  item.virtual_name }})</small>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade" :id="'kt_tab_pane_ws_' + index" role="tabpanel" v-for="item, index in this.addedWorksheets" v-bind:key="item">
                                <div class="table-responsive mt-1">
                                    <table class="table table-rounded border gy-4 gs-4 mt-2 text-gray-800">
                                        <thead>
                                            <tr>
                                                <th class="text-center"> {{ $t('selected') }} </th>
                                                <th> {{ $t('field') }} </th>
                                                <th class="text-center"> {{ $t('data_type') }} </th>
                                                <th class="text-center"> {{ $t('target_sql_field') }} </th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="this.excelFields.length > 0">
                                            <tr v-for="item in this.excelFields" v-bind:key="item" :class="{ 'bg-light': !item.isSelected, 'bg-light-success': item.isSelected }">
                                                <td class="align-middle border">
                                                    <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                                                        <input class="form-check-input" type="checkbox" v-model="item.isSelected" />
                                                    </div>
                                                </td>
                                                <td class="align-middle border">
                                                    <span class="badge badge-secondary me-2 p-2 fs-6">
                                                        <strong> {{ item.displayText }} </strong>  
                                                    </span>
                                                </td>
                                                <td class="align-middle text-center border">
                                                    <span class="badge badge-secondary">
                                                        {{ item.type }}
                                                    </span>
                                                </td>
                                                <td class="align-middle border">
                                                    <Select2 v-model="item.sqlField" :options="this.sqlFields" :settings="{ width: '100%', dropdownParent: '#kt_modal_desinger_data_import_template .modal-content' }" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table> 
                                </div>
                                <div class="col-lg-12 mt-5">
                                    <button class="btn btn-lg btn-success w-100" @click="onSaveExcelSettings()">
                                        <span class="svg-icon svg-icon-2">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                            <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                            </svg>
                                        </span> 
                                         {{ $t('save_excel_settings') }} 
                                    </button>
                                </div>
                            </div> 
                        </div> 
                </div>
            </div>
        </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios";
export default {
    name: "DataImportDesignerModal",
    data(){
        return {
            sourceList: [],
            form: { 
                category_id: 6,
                source: 1,
                clone_template: 0,
                description: null,
                file_type_id: 0
            },
            categoryList: [
                { id: 0, text: this.$t('select_an_option')},
                { id: 1, text: this.$t('accounts')},
                { id: 2, text: this.$t('bank_statement')},
                { id: 5, text: this.$t('collection')},
                { id: 3, text: this.$t('insurance_policy')},
                { id: 4, text: this.$t('invoice')},
                { id: 6, text: this.$t('bank_transaction') }
            ],
            sqlFields: [],
            dataTypes: [ 'None', 'Boolean' ,'Text' ,'Numeric' ,'DateTime' ,'Unknown' ],
            sheetNames: [],
            excelFields: [],
            excelContent: [],
            excelColumns: [],
            customExcelFields: [],
            fileSourceTypeList: [
                { id: 1, text: this.$t('excel_file') },
                { id: 2, text: this.$t('xml_file') }
            ],
            targetDatasetList: [
                { id: 0, text: this.$t('select_dataset') },
                { id: 1, text: this.$t('accounts') },
                { id: 2, text: this.$t('invoices') },
                { id: 3, text: this.$t('transactions') },
                { id: 4, text: this.$t('policies') }
            ],
            customRelationalFields: [],
            addedWorksheets: [],
            operator_values: [ 'SELECT AN OPERATOR', '>=', '<=', '==' , '!=', '<' ,'>' ,'OR' ,'BETWEEN' ],
            conditionFields: [],
            selectedColumn: { id: null, displayText: null },
            conditions: [],
            blocks: [],
            thenFields:[ 'SELECT AN OPTION', 'SAVE CUSTOM VALUE', 'SAVE VALUE', 'DO NOT SAVE VALUE' ],
            buttonRefs: []
        }; 
    },
    computed: {
        getConditionName() { 
            return (value)=>{
                if (value) {
                    var dataFound = this.excelFields.find(item =>item.id == value );
                    if(dataFound){
                        return dataFound.displayText;
                    } 
                    else{
                        if(value){
                            return value;
                        }
                        return null;
                    }
                }
            }
        }
    },
    methods: {
        onGetTemplate(){
            const params = {
                session_id: this.$getUser().session_id,
                id: this.$getSessionStorage('template_record_id')
            };
            axios.post('api/DataImport/GetDataImportTemplateById', params, {'Content-Type': 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){      
                    this.form = response.data;
                    this.onGetWorksheetParametersFromDB();
                }
            });
        },
        updateTemplate() {
            this.$swal(this.$t('success'), this.$t('template_update_succesfully'), 'success');
            this.$router.replace('/UpdateImportTemplate');
        },
        GetExcelDataByRecordID(sheetName){
            const params = {
                worksheet_name: sheetName,
                workbook_name: this.fileName,
                session_id: this.$getUser().session_id,
                file_type_id: this.form.file_type_id,
                record_id: this.$getSessionStorage('template_record_id')
            };    
            axios.post('/api/DataImport/GetExcelData', params, {'Content-Type': 'application/json'})
            .then((response) => { 
            this.excelContent = response.data.content;
            this.excelColumns = response.data.columns;
            this.excelFields = response.data.fields;
            })
            .catch((error) => {
                console.error(error);
            }); 
        },
        getXMLKeys(json_object, ret_array = []){
            for (var json_key in json_object) {
                if (typeof(json_object[json_key]) === 'object' && !Array.isArray(json_object[json_key])) {
                    ret_array.push(json_key);
                    this.getXMLKeys(json_object[json_key], ret_array);
                } else if (Array.isArray(json_object[json_key])) {
                    ret_array.push(json_key);
                    var first_element = json_object[json_key][0];
                    if (typeof(first_element) === 'object') {
                        this.getXMLKeys(first_element, ret_array);
                    }
                } else {
                    ret_array.push(json_key);
                }
            }

            return ret_array
        },
        onXMLFileChange(event){
            const formData = new FormData();
            formData.append('file', event.target.files[0]);
            this.fileName = event.target.files[0].name;
            fetch('/api/DataImport/GetXMLContent', {
                method: 'POST',
                body: formData,
                headers: {}
            }).then(response => response.json())
            .then(data => {
                // JSON Parse
                var allNodes = [];
                this.getXMLKeys(data, allNodes);
            });
        },
        onGetWorksheetParametersFromDB(){
            const parameters = {
                session_id: this.$getUser().session_id,
                template_id: this.$getSessionStorage('template_record_id')
            };        
            const requestOne =  axios.post('/api/DataImport/GetWorksheetParameters', parameters, {'Content-Type': 'application/json'});
            const requestTwo =  axios.post('/api/DataImport/GetFields', parameters, {'Content-Type': 'application/json'});        
            axios.all([requestOne, requestTwo]).then(axios.spread((...responses) => {
                this.addedWorksheets = responses[0].data;
                this.sqlFields = responses[1].data;
                if(this.addedWorksheets.length > 0) {
                    this.GetExcelDataByRecordID(this.addedWorksheets[0].name);                
                    setTimeout(() => {
                        this.buttonRefs[0]?.click();
                    }, 500);
                }
            }))
            .catch(errors => { 
                console.error(errors); 
            }); 
        },
        onSaveExcelSettings(){
            const fields = [];
            this.excelFields.forEach(element => {
                fields.push({
                    id: element.id,
                    columnOrder: parseInt(element.columnOrder),
                    sqlField: element.sqlField,
                    isSelected: element.isSelected ? 1 : 0
                })
            });
            const parameters = {
                session_id : this.$getUser().session_id,
                template_parameter_id: this.$getSessionStorage('template_record_id'),
                fields: fields
            };
            axios.post('/api/DataImport/UpdateExcelField', parameters, {'Content-Type': 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    this.$swal(this.$t('success'), this.$t('data_saved_succesfully'), 'success');
                }
            })
            .catch((error) => {
                console.error(error);
            });
        },
    },
};
</script>